<div class="tab-content-wrapper mt-4">
  @if (loading) {
    <app-preloader></app-preloader>
  }
  @if (!loading && form) {
    <form class="form form_crm" [formGroup]="form" novalidate>
      <div class="row no-gutters gutters-4">
        <div class="col-3">
          <app-material-input-radio formControlName="type" [data]="types">
          Тип собственности</app-material-input-radio>
        </div>
        <div class="col-9">
          @if (data['default_proprietors']) {
            <div  [ngClass]="{'d-none': form.value.type != 'no'}">
              <p>По умолчанию:</p>
              <table class="table table_middle">
                <tr>
                  <th style="width: 50px;">№</th>
                  <th>Собственник</th>
                  <th></th>
                </tr>
                @for (item of data['default_proprietors']; track item) {
                  <tr>
                    <td>1</td>
                    <td>{{item.caption}}</td>
                    <td>
                      @if (item.znamenatel && item.chislitel) {
                        {{item.znamenatel}}/{{item.chislitel}}
                      }
                    </td>
                  </tr>
                }
              </table>
            </div>
          }
          <div formArrayName="sob" [ngClass]="{'d-none': form.value.type != 'sob'}">
            <table class="table table_middle">
              <tr>
                <th style="width: 50px;">№</th>
                <th>Собственник</th>
              </tr>
              @for (item of sob.controls; track item; let id = $index) {
                <tr [formGroupName]="id">
                  <td>1</td>
                  <td>
                    <app-material-select2-autocomplete formControlName="value"
                      [api_action]="api_action"
                      [placeholder]="'Имя собственника или название организации'">
                      <option [value]="''">Имя собственника или название организации</option>
                      <option [value]="item.value.value">{{item.value.caption}}</option>
                    </app-material-select2-autocomplete>
                  </td>
                </tr>
              }
            </table>
            <div class="row no-gutters justify-content-end mt-3">
              <div class="col-6 text-right">
                <button class="button button_sub" (click)="physicalAdd()">Создать и добавить физ. лицо</button>
                <br>
                  <button class="button button_sub mt-2" (click)="entityAdd()">Создать и добавить юр. лицо</button>
                </div>
              </div>
            </div>
            <div formArrayName="sovm" [ngClass]="{'d-none': form.value.type != 'sovm'}">
              <table class="table table_middle">
                <tr>
                  <th style="width: 50px;">№</th>
                  <th>Собственник</th>
                  <th style="width: 50px;"></th>
                </tr>
                @for (item of sovm.controls; track item; let id = $index) {
                  <tr [formGroupName]="id">
                    <td>{{id + 1}}</td>
                    <td>
                      <app-material-select2-autocomplete formControlName="value"
                        [api_action]="api_action"
                        [placeholder]="'Имя собственника или название организации'">
                        <option [value]="''">Имя собственника или название организации</option>
                        <option [value]="item.value.value">{{item.value.caption}}</option>
                      </app-material-select2-autocomplete>
                    </td>
                    <td>
                      <a class="button button_icon button_icon_sub mr-1" (click)="sovmDelete(item)">
                        <i class="fa fa-trash-o"></i>
                      </a>
                    </td>
                  </tr>
                }
              </table>
              <div class="row no-gutters mt-3">
                <div class="col-6">
                  <button class="button button_sub" (click)="sovmAdd()">Добавить</button>
                </div>
                <div class="col-6 text-right">
                  <button class="button button_sub" (click)="physicalAdd()">Создать и добавить физ. лицо</button>
                  <br>
                    <button class="button button_sub mt-2" (click)="entityAdd()">Создать и добавить юр. лицо</button>
                  </div>
                </div>
              </div>
              <div formArrayName="dol" [ngClass]="{'d-none': form.value.type != 'dol'}">
                <table class="table table_middle">
                  <tr>
                    <th style="width: 50px;">№</th>
                    <th>Собственник</th>
                    <th style="width: 120px;">Доли</th>
                    <th style="width: 50px;"></th>
                  </tr>
                  @for (item of dol.controls; track item; let id = $index) {
                    <tr [formGroupName]="id">
                      <td>{{id + 1}}</td>
                      <td>
                        <app-material-select2-autocomplete formControlName="value"
                          [api_action]="api_action"
                          [placeholder]="'Имя собственника или название организации'">
                          <option [value]="''">Имя собственника или название организации</option>
                          <option [value]="item.value.value">{{item.value.caption}}</option>
                        </app-material-select2-autocomplete>
                      </td>
                      <td>
                        <div class="input__group__wrapper">
                          <div class="input__group">
                            <app-material-input formControlName="znamenatel"></app-material-input>
                            <app-material-input formControlName="chislitel"></app-material-input>
                          </div>
                        </div>
                      </td>
                      <td>
                        <a class="button button_icon button_icon_sub mr-1" (click)="dolDelete(item)">
                          <i class="fa fa-trash-o"></i>
                        </a>
                      </td>
                    </tr>
                  }
                </table>
                <div class="row no-gutters mt-3">
                  <div class="col-6">
                    <button class="button button_sub m-auto" (click)="dolAdd()">Добавить</button>
                  </div>
                  <div class="col-6 text-right">
                    <button class="button button_sub" (click)="physicalAdd()">Создать и добавить физ. лицо</button>
                    <br>
                      <button class="button button_sub mt-2" (click)="entityAdd()">Создать и добавить юр. лицо</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <hr>
                  <button (click)="saveForm()" type="button" class="button button_main">Сохранить</button>
                </div>
              </div>
            </form>
          }
        </div>
